// rules.jsx
import React, { useEffect, useState } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { initQuestions } from '../../functions/setUserQuestions';
import { selectAdminToken } from '../../admin/sessionSlice';
import { processQuestions } from '../../admin/questionSlice';
import { setBackButtonUrl } from '../uiSlice';
import IntroModal from '../introModal/introModal';


function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const { status, user, error } = useSelector((state) => state.auth);
  const [redirect, setRedirect] = useState("/life");
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [canProceedToNext, setCanProceedToNext] = useState(true);
  const adminToken = useSelector(selectAdminToken);
  
  console.log(themeData);

  useEffect(() => {
    if (!themeData || !user || !adminToken) return;

    dispatch(processQuestions())
      .unwrap()                               // unwraps the thunk's payload or throws
      .then(() => {
        return initQuestions({
          userId: user.userId,
          email: user.email,
          fullName: user.name,
          themeName: themeData.themename,
          token: adminToken
        });
      })
      .then(data => {
        console.log('Init response:', data);
        // e.g. store insertId or show first question…
      })
      .catch(err => {
        console.error('Error in process→init chain:', err);
      });
  }, [themeData, user, adminToken]);

  useEffect(() => {
    if (!themeData) return;
    
    if (!themeData.lifelines) {
      // If lifelines is false, redirect to quiz
      setRedirect("/quiz");
      // Don't show modal on load, only when Next is clicked
    } else {
      // If lifelines is true, go to lifelines page
      setRedirect("/life");
    }
  }, [themeData]);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

const handleIntroComplete = () => {
  setShowIntroModal(false);
  navigate(redirect); // Actually navigate to next page
};


  const handleCloseIntroModal = () => {
    setShowIntroModal(false);
    // If user closes without completing, still allow access
    // (you can change this behavior if needed)
    setCanProceedToNext(true);
  };

  const handleNextClick = (e) => {
    e.preventDefault();
    
    // If lifelines is false AND intro is enabled, show intro modal first
    if (!themeData.lifelines && themeData?.intro && themeData?.introFile) {
      setShowIntroModal(true);
      setCanProceedToNext(false);
      return;
    }
    
    // Otherwise proceed to next page directly
    navigate(redirect);
  };

  return (
    <>
      <div className="user-rules-container">
        <div className="user-rules-left">
          {/* Replace with your image or content */}
          <img
            src={process.env.REACT_APP_S3_PATH + themeData?.logo}
            alt="Who wants to be a champion"
            className="user-rules-image"
          />
        </div>
        <div className="user-rules-right">
          <div className="user-rules-big-title">{themeData?.main_title}</div>
          <div className="user-rules-subline">
            {themeData?.landing_page_title}
          </div>
          <div className="user-rules-heading">Rules</div>
          <ul className="user-rules-list">
            {
              themeData?.rules.map((rules, index) => (
                <li key={index}>
                  <i
                    className="fa fa-arrow-right user-rule-icon"
                    aria-hidden="true"
                  />
                  {rules}
                </li>
              ))
            }
          </ul>
          <div style={{ textAlign: "center" }}>
            <button 
              className="user-next-button"
              onClick={handleNextClick}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Intro Modal */}
      <IntroModal
        isOpen={showIntroModal}
        onClose={handleCloseIntroModal}
        onComplete={handleIntroComplete}
        introFile={themeData?.introFile}
      />
    </>
  )
}

export default UserRules;